module.exports = __webpack_public_path__ + "static/welcome-bg-f3c49d2cb5fee145c80e74cb10b16e4d.svg";